import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { User } from '../../user/model/user';
import { UserService } from '../../user/service/user.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { ActivatedRoute } from '@angular/router';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html' 
})
export class DonationComponent implements OnInit {
 
  appointments : any[];
  Users : User[];
  user:any;
  isAdmin = false;;
  private sub: any;
  startDate: string ="";
  endDate: string = "";
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  start: Object  = {};
  end: Object  = {};
  option: string = 'All';
  doctorId = '0';
  constructor(private _sharedService: SharedService, private route :ActivatedRoute,private _usrService : UserService, private _appSrv: AppointmentService) {
    let d = new Date();
    this.start =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    this.end =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
   
   }

  
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.Users=[];
    var id : any;
    let d = new Date();
     this.startDate=  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    this.endDate= d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();

          this.getAllCompletedDonations(this.startDate, this.endDate);  
  }
  
  showData() {
    this.appointments = [];
 
      this.showCompletedList();
     
  }
 
  showCompletedList() {
     
    if(this.startDate !="" && this.endDate !="") {
      this.getAllCompletedDonations(this.startDate, this.endDate);
    }
    
  }
 
  getAllCompletedDonations(startdate: string, enddate: string) {
    this._appSrv.GetAllDonationTransaction(startdate,enddate ).subscribe(data=>{ 
        this.appointments = data;
      
    },
    error=>{
       
    });
  }

 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  onDateChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.startDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.startDate=""; 
      return;
    }
  }
  onDateEndChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.endDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.endDate = "";
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }

 

}



// WEBPACK FOOTER //
// ./src/app/section/user/donation/donation.component.ts